// --- Configuration ---
const WOOD_VARIANT_ID = 55269399691639; // Wood Variant ID
const ACRYLIC_VARIANT_ID = 55269399724407; // Acrylic Variant ID
const FRONT_MATERIAL_NAME = 'etukuva';
const BACK_MATERIAL_NAME = 'takakuva';

// --- Shape Configuration ---
const SHAPES = {
    round: {
        wood: {
            silver: 'https://cdn.shopify.com/3d/models/79371cb863101e43/korvikset_py_reet_v3.glb',
            gold: 'https://cdn.shopify.com/3d/models/dba00005f11c27a5/korvikset_py_reet_kultakoukkuv3.glb'
        },
        acrylic: {
            silver: 'https://cdn.shopify.com/3d/models/d210f85d3e0011eb/korvikset_akryyli_ilmanreikaa.glb',
            gold: 'https://cdn.shopify.com/3d/models/43874bb7f148fac1/korvikset_py_reet_kultakoukku.glb'
        }
    },
    rectangle: {
        wood: {
            silver: 'https://cdn.shopify.com/3d/models/26d5fbb3d9894938/korvikset_suorakulma_v2.glb',
            gold: 'https://cdn.shopify.com/3d/models/fe45aef8f558f2f2/korvikset_suorakulma_kulta_v2.glb'
        },
        acrylic: {
            silver: null, // Not available yet
            gold: null    // Not available yet
        }
    }
};

// Legacy constants for backward compatibility
const WOOD_MODEL_URL = SHAPES.round.wood.silver;
const ACRYLIC_MODEL_URL = SHAPES.round.acrylic.silver;
const WOOD_GOLD_MODEL_URL = SHAPES.round.wood.gold;
const ACRYLIC_GOLD_MODEL_URL = SHAPES.round.acrylic.gold;

// --- CLOUDINARY CONFIGURATION ---
const CLOUDINARY_CLOUD_NAME = "dix1lcuzl";
const CLOUDINARY_UPLOAD_PRESET = "shopify_earring_customizer";

// --- Wood Texture ---
const WOOD_TEXTURE_URL = 'https://cdn.shopify.com/s/files/1/0901/1950/4247/files/Birch-Plywood.jpg?v=1746157736';
const FINAL_TEXTURE_SIZE = 1024; // The size of the final texture sent to Shopify
const FINAL_CROP_SCALE_ADJUSTMENT = 1.55; // Manual override: > 1 zooms out, < 1 zooms in.
const MANUAL_VERTICAL_OFFSET_FACTOR = -0.06; // Adjust this value! Start small (e.g., 0.01 to 0.05)
                                          // Positive values nudge the image UP on the final model.
                                          // Negative values nudge it DOWN.
const MANUAL_TEXTURE_SCALE_ADJUSTMENT = 0.77; // FOR ACRYLIC

// ADDING NEW CONSTANTS FOR WOOD:
const WOOD_MANUAL_TEXTURE_SCALE_ADJUSTMENT = 0.77; // Adjust for WOOD if needed (e.g., 0.95 if slightly too big)
const WOOD_MANUAL_VERTICAL_OFFSET_FACTOR = -0.064;   // Adjust for WOOD (e.g., positive if too low, negative if too high)

// --- Gold Hook Constants (separate adjustments for gold hook models) ---
const WOOD_GOLD_MANUAL_TEXTURE_SCALE_ADJUSTMENT = 0.77; // May need different scaling for gold hook model
const WOOD_GOLD_MANUAL_VERTICAL_OFFSET_FACTOR = -0.064;   // May need different offset for gold hook model
const ACRYLIC_GOLD_MANUAL_TEXTURE_SCALE_ADJUSTMENT = 0.77; // May need different scaling for gold hook model
const ACRYLIC_GOLD_MANUAL_VERTICAL_OFFSET_FACTOR = -0.06;   // May need different offset for gold hook model

// --- UV Scale Correction for 3D Preview ---
const WOOD_UV_SCALE_CORRECTION = 1.55;    // Value > 1 zooms OUT the texture on the model, < 1 zooms IN.
const ACRYLIC_UV_SCALE_CORRECTION = 1.55; // Adjust if acrylic model has different UV scaling.
const WOOD_UV_VERTICAL_OFFSET = 0.10;      // Positive values move the texture UP on the 3D model.
const ACRYLIC_UV_VERTICAL_OFFSET = 0.10;   // Adjust for acrylic model if needed.

// --- Gold Hook UV Corrections ---
const WOOD_GOLD_UV_SCALE_CORRECTION = 1.55;    // May need different UV scaling for gold hook
const WOOD_GOLD_UV_VERTICAL_OFFSET = 0.10;      // May need different vertical offset for gold hook
const ACRYLIC_GOLD_UV_SCALE_CORRECTION = 1.55;    // May need different UV scaling for gold hook
const ACRYLIC_GOLD_UV_VERTICAL_OFFSET = 0.10;   // May need different vertical offset for gold hook

// --- Global Variables ---
let scene, camera, renderer, controls;
let earringModel = null;
let frontMaterial = null;
let backMaterial = null;
let woodBaseTexture = null;
let isModelLoaded = false;
let uploadedImageUrl = null;
let customerCropSettings = null;
let currentMaterialType = 'wood'; // 'wood' or 'acrylic'
let currentHookType = 'silver'; // 'silver' or 'gold'
let currentShape = 'round'; // 'round' or 'rectangle'
let isAutorotating = false; // Flag to control rotation
let userHasInteracted = false; // Flag to manage autorotation state with interaction
let autorotationResumeTimer = null; // Timer for resuming autorotation
let currentModelUrl = WOOD_MODEL_URL;
let currentVariantId = WOOD_VARIANT_ID;
let isLoadingTexture = false; // Flag to prevent multiple texture loading operations

// --- Design Gallery System ---
let savedDesigns = []; // Array to hold saved designs
const MAX_SAVED_DESIGNS = 10; // Limit to prevent storage bloat

// --- DOM Elements ---
const canvasContainer = document.getElementById('earring-canvas-container');
const imageUploadInput = document.getElementById('image-upload');
const addToCartButton = document.getElementById('add-custom-to-cart-button');
const messageElement = document.getElementById('customizer-message');
const tabWood = document.getElementById('tab-wood');
const tabAcrylic = document.getElementById('tab-acrylic');
const tabSilverHook = document.getElementById('tab-silver-hook');
const tabGoldHook = document.getElementById('tab-gold-hook');

// --- Cropping Modal Elements & State ---
let cropModal = null;
let cropCanvas = null;
let cropCtx = null;
let cropImage = new Image(); // Image object for user's upload in modal
cropImage.crossOrigin = 'anonymous'; // IMPORTANT FOR CORS
let zoomSlider = null;
let applyCropBtn = null;
let cancelCropBtn = null;
let closeModalBtn = null;
let zoomInBtn = null;
let zoomOutBtn = null;
let cropCanvasContainer = null; // Container div for the crop canvas

let currentCropState = {
    scale: 1,
    offsetX: 0, // Panning offset X
    offsetY: 0, // Panning offset Y
    imageWidth: 0, // Original image dimensions
    imageHeight: 0
};
let isDragging = false;
let dragStartX = 0;
let dragStartY = 0;
let lastOffsetX = 0; // Offset at the start of a drag
let lastOffsetY = 0;

// --- Initialization ---
function init3D() {
    if (!canvasContainer) {
        // Silently return if canvasContainer is unexpectedly null.
        // The main DOMContentLoaded listener should prevent init3D from being called if the element doesn't exist.
        return;
    }

    // Basic Scene Setup
    scene = new THREE.Scene();
    scene.background = null;
    camera = new THREE.PerspectiveCamera(60, canvasContainer.clientWidth / canvasContainer.clientHeight, 0.1, 1000);
    camera.position.z = 3;
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(canvasContainer.clientWidth, canvasContainer.clientHeight);
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.toneMapping = THREE.NoToneMapping; // Restore original tone mapping
    renderer.outputEncoding = THREE.sRGBEncoding;
    renderer.shadowMap.enabled = false;
    canvasContainer.innerHTML = '';
    canvasContainer.appendChild(renderer.domElement);

    // Multi-light setup to simulate Shopify's IBL lighting
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.4);
    scene.add(ambientLight);

    // Key light (main)
    const keyLight = new THREE.DirectionalLight(0xffffff, 0.8);
    keyLight.position.set(5, 8, 5);
    scene.add(keyLight);

    // Fill light (opposite side)
    const fillLight = new THREE.DirectionalLight(0xffffff, 0.3);
    fillLight.position.set(-5, 3, -2);
    scene.add(fillLight);

    // Rim light (for edge highlights)
    const rimLight = new THREE.DirectionalLight(0xffffff, 0.4);
    rimLight.position.set(0, 2, -8);
    scene.add(rimLight);

    // Top light (for surface reflections)
    const topLight = new THREE.DirectionalLight(0xffffff, 0.3);
    topLight.position.set(0, 10, 0);
    scene.add(topLight);

    // Side lights for complex reflections
    const leftLight = new THREE.DirectionalLight(0xffffff, 0.2);
    leftLight.position.set(-8, 0, 2);
    scene.add(leftLight);

    const rightLight = new THREE.DirectionalLight(0xffffff, 0.2);
    rightLight.position.set(8, 0, 2);
    scene.add(rightLight);

    // Bottom light for under-lighting
    const bottomLight = new THREE.DirectionalLight(0xffffff, 0.15);
    bottomLight.position.set(0, -5, 3);
    scene.add(bottomLight);

    // Removed extra fill light to prevent over-exposure without tone mapping
    // const fillLight = new THREE.DirectionalLight(0xffffff, 0.3); // Softer fill light from the side
    // fillLight.position.set(-5, 5, -5);
    // scene.add(fillLight);

    // Controls
    controls = new THREE.OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true;
    controls.dampingFactor = 0.05;
    controls.minDistance = 1;
    controls.maxDistance = 10;

    // Autorotation logic based on user drag interaction
    controls.addEventListener('start', () => {
        if (isAutorotating) {
            console.log('User drag started. Stopping autorotation.');
            isAutorotating = false; // Stop current rotation when user starts dragging
        }
        userHasInteracted = true;   // Mark that user is actively interacting
        if (autorotationResumeTimer) {
            clearTimeout(autorotationResumeTimer);
            autorotationResumeTimer = null;
        }
    });

    controls.addEventListener('end', () => {
        // If the user was interacting (dragged the model) and autorotation is currently off
        if (userHasInteracted && !isAutorotating) {
            if (autorotationResumeTimer) clearTimeout(autorotationResumeTimer);
            console.log('User drag ended. Setting 5s timer to resume autorotation.');
            autorotationResumeTimer = setTimeout(() => {
                console.log('5s inactivity timer elapsed. Resuming autorotation.');
                isAutorotating = true;
                userHasInteracted = false; // Reset for next interaction cycle
                autorotationResumeTimer = null;
            }, 5000); // 5 seconds
        }
    });

    // --- Wood Texture Preloading ---
    console.log("Ladataan puun perusrakennetta...");
    const textureLoader = new THREE.TextureLoader();
    textureLoader.load(
        WOOD_TEXTURE_URL,
        (texture) => {
            woodBaseTexture = texture;
            // Set appropriate wrapping based on whether wood texture is tileable
            // woodBaseTexture.wrapS = THREE.RepeatWrapping;
            // woodBaseTexture.wrapT = THREE.RepeatWrapping;
             woodBaseTexture.wrapS = THREE.ClampToEdgeWrapping; // If texture is meant to stretch 1:1
             woodBaseTexture.wrapT = THREE.ClampToEdgeWrapping;
            woodBaseTexture.needsUpdate = true;
            console.log("Puun perusrakenne ladattu onnistuneesti.");
            // Don't load model here - it will be loaded by init3D after texture loading
        },
        undefined,
        (err) => {
            console.error("Virhe ladattaessa puun perusrakennetta:", err);
            showMessage("Virhe: Puun perusrakennetta ei voitu ladata.", true);
            woodBaseTexture = null;
            // Don't load model here - it will be loaded by init3D after texture loading
        }
    );

    animate(); // Start animation loop

    // Handle Resize
    window.addEventListener('resize', onWindowResize);
    
    // Load initial model after scene setup
    currentModelUrl = getCurrentModelUrl();
    loadModel(currentModelUrl);
}

// --- Load GLB Model (with Autorotation Start) ---
function loadModel(modelUrlToLoad) {
    console.log('loadModel called with URL:', modelUrlToLoad);
    
    if (!modelUrlToLoad) {
        console.error('loadModel called with undefined URL');
        showMessage('Virhe: Mallin URL puuttuu.', true);
        return;
    }
    
    // Clear ALL models from scene to prevent duplicates
    const modelsToRemove = [];
    scene.traverse((child) => {
        if (child.isMesh || child.isGroup) {
            modelsToRemove.push(child);
        }
    });
    
    modelsToRemove.forEach((model) => {
        scene.remove(model);
        if (model.traverse) {
            model.traverse(child => {
                if (child.isMesh) {
                    if (child.geometry) child.geometry.dispose();
                    if (child.material) {
                        if (Array.isArray(child.material)) {
                            child.material.forEach(material => material.dispose());
                        } else {
                            child.material.dispose();
                        }
                    }
                }
            });
        }
    });
    
    earringModel = null;
    frontMaterial = null;
    backMaterial = null;
    isModelLoaded = false;
    showMessage('Ladataan uutta mallia...'); // Inform user

    const loader = new THREE.GLTFLoader();
    loader.load(
        modelUrlToLoad,
        (gltf) => {
            earringModel = gltf.scene; // Store model reference globally
            const box = new THREE.Box3().setFromObject(earringModel);
            const center = box.getCenter(new THREE.Vector3());
            earringModel.position.sub(center); // Center the model
            earringModel.rotation.y = -0.2; // Rotate slightly to the right (clockwise) to face camera more directly
          const MANUAL_CENTER_X_OFFSET = -0.25; // Adjust this value! Negative moves model LEFT, Positive moves model RIGHT. Start small!
            earringModel.position.x += MANUAL_CENTER_X_OFFSET; // Apply manual X offset

            // Traverse to find materials
            earringModel.traverse((node) => {
                if (node.isMesh && node.material) {
                    const materials = Array.isArray(node.material) ? node.material : [node.material];
                    materials.forEach(material => {
                        if (material.name === FRONT_MATERIAL_NAME) frontMaterial = material;
                        else if (material.name === BACK_MATERIAL_NAME) backMaterial = material;
                    });
                }
            });

            // Update materials only once after finding them
            if(frontMaterial) frontMaterial.needsUpdate = true;
            if(backMaterial) backMaterial.needsUpdate = true;

            // Check if materials were found
            if (!frontMaterial || !backMaterial) {
                console.error(`Could not find materials: '${FRONT_MATERIAL_NAME}', '${BACK_MATERIAL_NAME}'.`);
                showMessage("Virhe: 3D-esikatselua ei voitu alustaa täysin.", true);
                return;
            }
            console.log("Materials found.");

            // Add model to the scene
            scene.add(earringModel);
            isModelLoaded = true;
            console.log(`Model loaded: ${modelUrlToLoad}. Front material found: ${!!frontMaterial}, Back material found: ${!!backMaterial}`);
            if (currentMaterialType === 'acrylic') {
                console.log('Acrylic model specific material check:', frontMaterial, backMaterial);
            }
            showMessage(''); // Clear loading message
            console.log("Model loaded successfully.");



            // Set Initial Camera View
            if (currentMaterialType === 'acrylic') {
                camera.position.set(0, 0, 3.8); // Zoom in slightly more for acrylic
            } else if (currentMaterialType === 'wood' && currentHookType === 'gold') {
                camera.position.set(0, 0, 3.2); // Closer for wood with gold hook
            } else {
                camera.position.set(0, 0, 3.2); // Same distance for wood with silver hook
            }
           // controls.target.set(0, 0, 0); // Ensure target is at origin if model is centered
            controls.update(); // Apply camera changes

            // --- START AUTOROTATION ---
            if (!userHasInteracted) { // Only start if user hasn't already interacted
                 console.log("Starting autorotation.");
                 isAutorotating = true;
            }
            // --- END START AUTOROTATION ---

            // --- ADD LISTENER TO STOP ROTATION ---
            // Use { once: true } so it automatically removes itself after first interaction
            controls.addEventListener('start', handleUserInteraction, { once: true });
            console.log("Added one-time listener to stop autorotation.");
            // --- END ADD LISTENER ---

            // Enable the image upload input if it exists
            if (imageUploadInput) imageUploadInput.disabled = false;

        },
        (xhr) => { // Progress callback
             console.log(`Model load: ${(xhr.loaded / xhr.total * 100).toFixed(0)}%`);
        },
        (error) => { // Error callback
            console.error('Error loading GLB:', error);
            showMessage("Error loading 3D preview.", true);
        }
    );
}

// --- Material Switching Logic ---
function switchMaterial(newMaterialType) {
    // Check if acrylic is compatible with current selections
    if (newMaterialType === 'acrylic') {
        if (currentShape === 'rectangle') {
            showMessage('Akryyli ei ole saatavilla suorakaide-muodolle. Valitse pyöreä muoto.', true);
            return;
        }
        if (currentHookType === 'gold') {
            showMessage('Akryyli ei ole saatavilla kultakoukulle. Valitse hopeakoukku.', true);
            return;
        }
    }
    
    if (newMaterialType === currentMaterialType && isModelLoaded) return; // Avoid reloading if same material and model loaded

    currentMaterialType = newMaterialType;
    
    // Reset to silver hook if switching to acrylic (gold not available for acrylic)
    if (newMaterialType === 'acrylic' && currentHookType === 'gold') {
        currentHookType = 'silver';
        if(tabSilverHook) tabSilverHook.classList.add('active');
        if(tabGoldHook) tabGoldHook.classList.remove('active');
    }
    
    // Reset to round shape if switching to acrylic (rectangle not available for acrylic)
    if (newMaterialType === 'acrylic' && currentShape === 'rectangle') {
        currentShape = 'round';
        const roundTab = document.getElementById('tab-round');
        const rectangleTab = document.getElementById('tab-rectangle');
        if (roundTab) roundTab.classList.add('active');
        if (rectangleTab) rectangleTab.classList.remove('active');
    }
    
    updateHookTabsVisibility();
    updateShapeTabsVisibility();
    updateMaterialTabsVisibility();
    
    if(tabWood) tabWood.classList.toggle('active', newMaterialType === 'wood');
    if(tabAcrylic) tabAcrylic.classList.toggle('active', newMaterialType === 'acrylic');

    // Reset image and texture state
    uploadedImageUrl = null; 
    customerCropSettings = null;
    if(imageUploadInput) imageUploadInput.value = ''; // Clear file input
    if(addToCartButton) addToCartButton.disabled = true; // Disable until new image uploaded for new material
    if(messageElement) messageElement.textContent = 'Valitse kuva uudelle materiaalille.';
    
    // Load the new model
    currentModelUrl = getCurrentModelUrl();
    console.log('Loading model for acrylic:', currentModelUrl);
    loadModel(currentModelUrl);
}

// --- Update Hook Tabs Visibility ---
function updateHookTabsVisibility() {
    if (tabGoldHook) {
        if (currentMaterialType === 'acrylic') {
            tabGoldHook.style.opacity = '0.5';
            tabGoldHook.style.cursor = 'not-allowed';
            tabGoldHook.disabled = true;
        } else {
            tabGoldHook.style.opacity = '1';
            tabGoldHook.style.cursor = 'pointer';
            tabGoldHook.disabled = false;
        }
    }
}

// --- Update Shape Tabs Visibility ---
function updateShapeTabsVisibility() {
    const rectangleTab = document.getElementById('tab-rectangle');
    if (rectangleTab) {
        if (currentMaterialType === 'acrylic') {
            rectangleTab.style.opacity = '0.5';
            rectangleTab.style.cursor = 'not-allowed';
            rectangleTab.disabled = true;
        } else {
            rectangleTab.style.opacity = '1';
            rectangleTab.style.cursor = 'pointer';
            rectangleTab.disabled = false;
        }
    }
}

// --- Update Material Tabs Visibility ---
function updateMaterialTabsVisibility() {
    if (tabAcrylic) {
        if (currentShape === 'rectangle' || currentHookType === 'gold') {
            tabAcrylic.style.opacity = '0.5';
            tabAcrylic.style.cursor = 'not-allowed';
            tabAcrylic.disabled = true;
        } else {
            tabAcrylic.style.opacity = '1';
            tabAcrylic.style.cursor = 'pointer';
            tabAcrylic.disabled = false;
        }
    }
}

function switchShape(shape) {
    console.log(`Switching to ${shape} shape`);
    
    // Check if rectangle is compatible with current material
    if (shape === 'rectangle' && currentMaterialType === 'acrylic') {
        showMessage('Suorakaide-muoto ei ole saatavilla akryylille. Valitse puu-materiaali.', true);
        return;
    }
    
    // Update current shape
    currentShape = shape;
    
    // Reset to wood if switching to rectangle and currently acrylic
    if (shape === 'rectangle' && currentMaterialType === 'acrylic') {
        currentMaterialType = 'wood';
        if(tabWood) tabWood.classList.add('active');
        if(tabAcrylic) tabAcrylic.classList.remove('active');
    }
    
    // Update shape tabs visual state
    const roundTab = document.getElementById('tab-round');
    const rectangleTab = document.getElementById('tab-rectangle');
    
    if (roundTab && rectangleTab) {
        roundTab.classList.toggle('active', shape === 'round');
        rectangleTab.classList.toggle('active', shape === 'rectangle');
    }
    
    // Check if the selected combination is available
    const modelUrl = SHAPES[currentShape][currentMaterialType][currentHookType];
    if (!modelUrl) {
        // If rectangle + acrylic, disable and show message
        if (currentShape === 'rectangle' && currentMaterialType === 'acrylic') {
            showMessage('Suorakaide-muoto ei ole vielä saatavilla akryylille. Valitse puu-materiaali.', true);
            // Switch back to round
            currentShape = 'round';
            roundTab.classList.add('active');
            rectangleTab.classList.remove('active');
            return;
        }
    }
    
    // Update model URL and reload
    currentModelUrl = getCurrentModelUrl();
    
    // Clear existing textures from materials if model is loaded (it will be reloaded)
    if (frontMaterial && frontMaterial.map) {
        frontMaterial.map = null;
        frontMaterial.needsUpdate = true;
    }
    if (backMaterial && backMaterial.map) {
        backMaterial.map = null;
        backMaterial.needsUpdate = true;
    }

    loadModel(currentModelUrl);
}

function switchHook(hookType) {
    console.log(`Switching to ${hookType} hook`);
    
    // Check if gold hook is compatible with current material
    if (hookType === 'gold' && currentMaterialType === 'acrylic') {
        showMessage('Kultakoukku ei ole saatavilla akryylille. Valitse hopeakoukku.', true);
        return;
    }
    
    currentHookType = hookType;
    
    // Reset to wood if switching to gold and currently acrylic
    if (hookType === 'gold' && currentMaterialType === 'acrylic') {
        currentMaterialType = 'wood';
        if(tabWood) tabWood.classList.add('active');
        if(tabAcrylic) tabAcrylic.classList.remove('active');
    }
    
    // Update hook tabs visual state
    if(tabSilverHook) tabSilverHook.classList.toggle('active', hookType === 'silver');
    if(tabGoldHook) tabGoldHook.classList.toggle('active', hookType === 'gold');
    
    // Update visibility states
    updateMaterialTabsVisibility();
    updateHookTabsVisibility();
    updateShapeTabsVisibility();
    
    // Check if model combination is available
    const modelUrl = SHAPES[currentShape][currentMaterialType][currentHookType];
    if (!modelUrl) {
        showMessage('Tämä yhdistelmä ei ole vielä saatavilla.', true);
        return;
    }
    
    // Update model URL and load new model
    currentModelUrl = getCurrentModelUrl();
    loadModel(currentModelUrl);
}

// --- Update Model URL Based on Current Material and Hook ---
function getCurrentModelUrl() {
    console.log(`Getting model URL for: ${currentShape} ${currentMaterialType} ${currentHookType}`);
    const modelUrl = SHAPES[currentShape][currentMaterialType][currentHookType];
    console.log('Model URL found:', modelUrl);
    if (!modelUrl) {
        console.warn(`No model available for ${currentShape} ${currentMaterialType} ${currentHookType}`);
        return WOOD_MODEL_URL; // Fallback to default
    }
    return modelUrl;
}
// --- Handle First User Interaction (Stops Autorotation) ---
// --- Handle First User Interaction (Stops Initial Autorotation if active) ---
function handleUserInteraction() {
    // This function is called ONCE by a listener with { once: true }
    // when the user first interacts with the controls after a model load.
    if (isAutorotating) {
        console.log("First user interaction detected while autorotating. Stopping initial autorotation.");
        isAutorotating = false;
    }
    userHasInteracted = true; // Mark that user has now taken control at least once.
                               // Subsequent drag interactions will be handled by listeners in init3DControls.
    // The { once: true } listener that calls this is in loadModel's GLTF callback.
}

// --- Setup listeners for modal ---
// --- NEW: Setup listeners for modal ---
function setupModalEventListeners() {
    console.log('Setting up modal event listeners');
    console.log('applyCropBtn:', applyCropBtn);
    if (!cropModal || !cropCanvas || !zoomSlider || !applyCropBtn || !cancelCropBtn || !closeModalBtn || !zoomInBtn || !zoomOutBtn || !cropCanvasContainer) {
        console.error("One or more modal elements missing. Cannot add listeners.");
        console.error('Missing elements:', {
            cropModal: !!cropModal,
            cropCanvas: !!cropCanvas,
            zoomSlider: !!zoomSlider,
            applyCropBtn: !!applyCropBtn,
            cancelCropBtn: !!cancelCropBtn,
            closeModalBtn: !!closeModalBtn,
            zoomInBtn: !!zoomInBtn,
            zoomOutBtn: !!zoomOutBtn,
            cropCanvasContainer: !!cropCanvasContainer
        });
        return;
    }

    // Close Buttons
    closeModalBtn.addEventListener('click', hideModal); // Use updated function name
    cancelCropBtn.addEventListener('click', hideModal); // Use updated function name

    // Apply Button
    console.log('Adding click listener to applyCropBtn');
    applyCropBtn.addEventListener('click', function(e) {
        console.log('Apply crop button clicked!');
        e.preventDefault();
        applyCropAndGenerateTexture();
    });

    // Zoom Controls
    zoomSlider.addEventListener('input', handleZoomSlider);
    zoomInBtn.addEventListener('click', () => adjustZoom(0.03));
    zoomOutBtn.addEventListener('click', () => adjustZoom(-0.03));

    // Panning Listeners (on the canvas container)
    cropCanvasContainer.addEventListener('mousedown', startDrag);
    cropCanvasContainer.addEventListener('mousemove', drag);
    window.addEventListener('mouseup', endDrag); // Listen on window for release
    cropCanvasContainer.addEventListener('mouseleave', endDrag);

    // Touch Events
    cropCanvasContainer.addEventListener('touchstart', startDrag, { passive: false });
    cropCanvasContainer.addEventListener('touchmove', drag, { passive: false });
    cropCanvasContainer.addEventListener('touchend', endDrag);
    cropCanvasContainer.addEventListener('touchcancel', endDrag);

    console.log("Modal event listeners set up.");
}

// --- Zoom Handling ---
function handleZoomSlider(event) {
    // Ensure the slider value is treated as a number when updating state
    currentCropState.scale = parseFloat(event.target.value);
    drawCropCanvas();
}

function adjustZoom(amount) {
    // Read min/max directly from the slider element each time
    // Use fallback values consistent with the HTML defaults if slider isn't found
    const minZoom = parseFloat(zoomSlider?.min || 0.3);
    const maxZoom = parseFloat(zoomSlider?.max || 4.0);

    // Ensure the current scale and amount are treated as numbers
    const currentScale = parseFloat(currentCropState.scale);
    const numericAmount = parseFloat(amount); // Ensure amount is also treated as a number

    // Calculate the potential new scale
    let newScale = currentScale + numericAmount;

    // Clamp the new scale within the slider's defined bounds
    // Use Math.round with precision if step requires it, otherwise Math.max/min is fine
    newScale = Math.max(minZoom, Math.min(maxZoom, newScale));

    // Optional: If you want the button presses to snap exactly to slider steps (0.01),
    // you could round the newScale to the nearest step increment.
    // const step = parseFloat(zoomSlider?.step || 0.01);
    // newScale = Math.round(newScale / step) * step;
    // newScale = Math.max(minZoom, Math.min(maxZoom, newScale)); // Clamp again after rounding

    // Update the state
    currentCropState.scale = newScale;

    // Update the slider's visual position to match the new state
    if (zoomSlider) {
      zoomSlider.value = newScale;
    }

    // Redraw the canvas with the updated scale
    drawCropCanvas();
}

// --- Panning (Drag) Handling ---
function getEventCoordinates(event) {
    if (event.touches && event.touches.length > 0) {
        return { x: event.touches[0].clientX, y: event.touches[0].clientY };
    }
    return { x: event.clientX, y: event.clientY };
}

function startDrag(event) {
    if (event.type === 'touchstart') event.preventDefault();
    isDragging = true;
    const coords = getEventCoordinates(event);
    dragStartX = coords.x;
    dragStartY = coords.y;
    lastOffsetX = currentCropState.offsetX;
    lastOffsetY = currentCropState.offsetY;
    if (cropCanvasContainer) cropCanvasContainer.style.cursor = 'grabbing';
}

function drag(event) {
    if (!isDragging) return;
    if (event.type === 'touchmove') event.preventDefault();
    const coords = getEventCoordinates(event);
    const dx = coords.x - dragStartX;
    const dy = coords.y - dragStartY;
    currentCropState.offsetX = lastOffsetX + dx;
    currentCropState.offsetY = lastOffsetY + dy;
    drawCropCanvas();
}

function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    if (cropCanvasContainer) cropCanvasContainer.style.cursor = 'grab';
}

function drawCropCanvas() {
    if (!cropCanvas || !cropCtx || !cropImage.src || cropImage.naturalWidth === 0) {
        return; // Exit if canvas isn't ready or image has no data
    }

    const canvasWidth = cropCanvas.width;
    const canvasHeight = cropCanvas.height;

    // Clear the entire canvas
    cropCtx.clearRect(0, 0, canvasWidth, canvasHeight);

    // --- Enable High-Quality Image Scaling ---
    cropCtx.imageSmoothingEnabled = true;
    cropCtx.imageSmoothingQuality = 'high';

    // --- 1. Draw the user's panned and zoomed image ---
    cropCtx.save();
    const { scale, offsetX, offsetY, imageWidth, imageHeight } = currentCropState;
    const scaledWidth = imageWidth * scale;
    const scaledHeight = imageHeight * scale;
    const dx = (canvasWidth - scaledWidth) / 2 + offsetX;
    const dy = (canvasHeight - scaledHeight) / 2 + offsetY;
    cropCtx.drawImage(cropImage, dx, dy, scaledWidth, scaledHeight);
    cropCtx.restore();

    // --- 2. Draw the semi-transparent overlay with a circular hole ---
    cropCtx.save();
    const centerX = canvasWidth / 2;
    const centerY = canvasHeight / 2;
    
    // Create the overlay based on current shape
    cropCtx.fillStyle = 'rgba(0, 0, 0, 0.4)';
    cropCtx.beginPath();
    // Define the outer rectangle covering the whole canvas
    cropCtx.rect(0, 0, canvasWidth, canvasHeight);
    
    if (currentShape === 'rectangle') {
        // Rectangle crop area - aspect ratio 1.02:1.71 (width:height)
        const cropWidth = Math.min(canvasWidth, canvasHeight) * 0.6;
        const cropHeight = cropWidth * (1.71 / 1.02); // 1.02:1.71 ratio
        const cropX = centerX - cropWidth / 2;
        const cropY = centerY - cropHeight / 2;
        
        // Define the inner rectangular path in reverse to create the 'hole'
        cropCtx.rect(cropX, cropY, cropWidth, cropHeight);
        cropCtx.closePath();
        // Fill the area between the outer rectangle and the inner rectangle
        cropCtx.fill('evenodd');
        
        // Draw a crisp white border for the rectangle
        cropCtx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
        cropCtx.lineWidth = 2;
        cropCtx.beginPath();
        cropCtx.rect(cropX, cropY, cropWidth, cropHeight);
        cropCtx.stroke();
    } else {
        // Round crop area (original circular logic)
        const radius = Math.min(canvasWidth, canvasHeight) / 2;
        
        // Define the inner circular path in reverse to create the 'hole'
        cropCtx.arc(centerX, centerY, radius, 0, Math.PI * 2, true);
        cropCtx.closePath();
        // Fill the area between the rectangle and the circle
        cropCtx.fill();

        // Draw a crisp white border for the circle
        cropCtx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
        cropCtx.lineWidth = 2;
        cropCtx.beginPath();
        cropCtx.arc(centerX, centerY, radius, 0, Math.PI * 2, false);
        cropCtx.stroke();
    }

    cropCtx.restore();
}

// --- Modal Visibility & Image Handling ---
function showModal() {
    if (cropModal) {
        cropModal.classList.remove('crop-modal-hidden');
        cropModal.classList.add('crop-modal-visible');
    }
}

function hideModal() {
    if (cropModal) {
        cropModal.classList.remove('crop-modal-visible');
        cropModal.classList.add('crop-modal-hidden');
    }
}

function handleImageUpload(event) {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
        cropImage.onload = () => {
            if (!cropCanvas || !cropCanvasContainer) {
                console.error("Cannot process image: canvas elements not found.");
                return;
            }
            // Set the image dimensions in our state object FIRST
            currentCropState.imageWidth = cropImage.naturalWidth;
            currentCropState.imageHeight = cropImage.naturalHeight;

            // Now, show the modal so its container has dimensions
            showModal();

            // THEN, resize the canvas to match the now-visible container
            const { clientWidth, clientHeight } = cropCanvasContainer;
            cropCanvas.width = clientWidth;
            cropCanvas.height = clientHeight;

            // With the canvas and image dimensions set, reset the state
            resetCropState();

            // Finally, draw the canvas for the first time
            drawCropCanvas();
        };
        cropImage.onerror = () => {
            console.error("Error loading image data.");
            showMessage("Kuvaa ei voitu ladata. Kokeile toista kuvaa.", true);
        };
        cropImage.src = e.target.result;
    };
    reader.readAsDataURL(file);
}

function resetCropState() {
    if (!cropCanvas || !zoomSlider || currentCropState.imageWidth === 0) {
        return; // Exit if elements aren't ready
    }

    const canvasWidth = cropCanvas.width;
    const canvasHeight = cropCanvas.height;
    const imageWidth = currentCropState.imageWidth;
    const imageHeight = currentCropState.imageHeight;

    // Calculate the two important scales
    const scaleToFit = Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight);
    const scaleToCover = Math.max(canvasWidth / imageWidth, canvasHeight / imageHeight);

    // Set the state to start at the 'cover' scale (no empty space)
    currentCropState.scale = scaleToCover;
    currentCropState.offsetX = 0;
    currentCropState.offsetY = 0;

    // Configure the slider's range and starting point
    zoomSlider.min = scaleToFit * 0.5; // Allow zooming out 2x further than 'fit'
    zoomSlider.max = scaleToCover * 3;  // Allow zooming in 3x from the initial 'cover' view
    zoomSlider.step = '0.001';          // Provide smooth, granular zoom control
    zoomSlider.value = scaleToCover;  // Start the slider at the 'cover' position
}

async function uploadCroppedImageToCloudinary(imageBlob) {
    const formData = new FormData();
    formData.append('file', imageBlob, 'custom_earring.png');
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);

    const response = await fetch(`https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`, {
        method: 'POST',
        body: formData
    });

    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Cloudinary upload failed: ${errorData.error.message}`);
    }

    const data = await response.json();
    // IMPORTANT: Manually construct the URL if `secure_url` is not in the response.
    if (!data.secure_url) {
        data.secure_url = `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/v${data.version}/${data.public_id}.${data.format}`;
    }
    return data;
}

async function applyCropAndGenerateTexture() {
    console.log('applyCropAndGenerateTexture called');
    if (!cropImage.src || isLoadingTexture) {
        console.log('Early return: no image src or already loading');
        return;
    }
    isLoadingTexture = true;
    showMessage('Käsitellään kuvaa...');
    if (addToCartButton) addToCartButton.disabled = true;

    try {
        // Step 1: Create the final cropped image on a new canvas
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = FINAL_TEXTURE_SIZE;
        finalCanvas.height = FINAL_TEXTURE_SIZE;
        const finalCtx = finalCanvas.getContext('2d');

        const { scale, offsetX, offsetY, imageWidth, imageHeight } = currentCropState;

        // Calculate crop dimensions based on shape
        let sourceVisibleWidth, sourceVisibleHeight;
        
        if (currentShape === 'rectangle') {
            // Rectangle crop dimensions - aspect ratio 1.02:1.71 (width:height)
            const cropWidth = Math.min(cropCanvas.width, cropCanvas.height) * 0.6;
            const cropHeight = cropWidth * (1.71 / 1.02);
            sourceVisibleWidth = cropWidth / scale;
            sourceVisibleHeight = cropHeight / scale;
        } else {
            // Circular crop dimensions (original logic)
            const cropRadius = Math.min(cropCanvas.width, cropCanvas.height) / 2;
            sourceVisibleWidth = (cropRadius * 2) / scale;
            sourceVisibleHeight = sourceVisibleWidth; // Square for circle
        }

        // 1. Find the center of the crop area in the source image, including pan offsets.
        const cropCenterX = (imageWidth / 2) - (offsetX / scale);
        const cropCenterY = (imageHeight / 2) - (offsetY / scale);

        // 2. Calculate the top-left corner (sourceX, sourceY) from the center and the visible size.
        const sourceX = cropCenterX - (sourceVisibleWidth / 2);
        const sourceY = cropCenterY - (sourceVisibleHeight / 2);

        // Draw the cropped image only within the designated area, not stretched to full canvas
        if (currentShape === 'rectangle') {
            const rectWidth = FINAL_TEXTURE_SIZE * 1; // Increase width to eliminate side gaps
            const rectHeight = rectWidth * (1.71 / 1.02) * 0.6; // Reduce vertical stretch by 15%
            const rectX = (FINAL_TEXTURE_SIZE - rectWidth) / 2;
            const rectY = (FINAL_TEXTURE_SIZE - rectHeight) / 2;
            finalCtx.drawImage(cropImage, sourceX, sourceY, sourceVisibleWidth, sourceVisibleHeight, rectX, rectY, rectWidth, rectHeight);
        } else {
            // For circular, draw to full canvas as before
            finalCtx.drawImage(cropImage, sourceX, sourceY, sourceVisibleWidth, sourceVisibleHeight, 0, 0, FINAL_TEXTURE_SIZE, FINAL_TEXTURE_SIZE);
        }

        finalCtx.globalCompositeOperation = 'destination-in';
        finalCtx.beginPath();
        
        if (currentShape === 'rectangle') {
            // Rectangle mask for final texture - match the drawing dimensions
            const rectWidth = FINAL_TEXTURE_SIZE * 1; // Match the increased width
            const rectHeight = rectWidth * (1.71 / 1.02) * 0.6; // Match the reduced vertical stretch
            const rectX = (FINAL_TEXTURE_SIZE - rectWidth) / 2;
            const rectY = (FINAL_TEXTURE_SIZE - rectHeight) / 2;
            finalCtx.rect(rectX, rectY, rectWidth, rectHeight);
        } else {
            // Circle mask for final texture (original)
            finalCtx.arc(FINAL_TEXTURE_SIZE / 2, FINAL_TEXTURE_SIZE / 2, FINAL_TEXTURE_SIZE / 2, 0, Math.PI * 2);
        }
        
        finalCtx.fill();
        finalCtx.globalCompositeOperation = 'source-over';

        // Step 2: Create upload canvas with actual crop dimensions (not square)
        const uploadCanvas = document.createElement('canvas');
        let uploadWidth, uploadHeight;
        
        if (currentShape === 'rectangle') {
            // Use actual rectangular dimensions for upload
            uploadWidth = 1024; // Base width
            uploadHeight = uploadWidth * (1.71 / 1.02); // Actual aspect ratio height
        } else {
            // Keep square for circular
            uploadWidth = FINAL_TEXTURE_SIZE;
            uploadHeight = FINAL_TEXTURE_SIZE;
        }
        
        uploadCanvas.width = uploadWidth;
        uploadCanvas.height = uploadHeight;
        const uploadCtx = uploadCanvas.getContext('2d');
        
        // Draw the cropped image to fill the entire upload canvas
        if (currentShape === 'rectangle') {
            uploadCtx.drawImage(cropImage, sourceX, sourceY, sourceVisibleWidth, sourceVisibleHeight, 0, 0, uploadWidth, uploadHeight);
        } else {
            uploadCtx.drawImage(cropImage, sourceX, sourceY, sourceVisibleWidth, sourceVisibleHeight, 0, 0, uploadWidth, uploadHeight);
            // Apply circular mask
            uploadCtx.globalCompositeOperation = 'destination-in';
            uploadCtx.beginPath();
            uploadCtx.arc(uploadWidth / 2, uploadHeight / 2, uploadWidth / 2, 0, Math.PI * 2);
            uploadCtx.fill();
            uploadCtx.globalCompositeOperation = 'source-over';
        }
        
        // Convert upload canvas to blob and upload to Cloudinary
        const blob = await new Promise(resolve => uploadCanvas.toBlob(resolve, 'image/png'));
        const uploadResponse = await uploadCroppedImageToCloudinary(blob);

        // Step 3: CRITICAL - Securely get the URL
        const imageUrl = uploadResponse.secure_url;
        if (!imageUrl) {
            throw new Error('Cloudinary response did not include a secure_url.');
        }
        uploadedImageUrl = imageUrl; // Set the global URL
        customerCropSettings = { ...currentCropState };

        // Step 4: Load the URL as a texture for Three.js
        const textureLoader = new THREE.TextureLoader();
        textureLoader.setCrossOrigin('anonymous');
        const finalTexture = await textureLoader.loadAsync(uploadedImageUrl);

        // Step 5: Apply the texture to the model
        configureAndApplyTexture(finalTexture);

        showMessage('Valmis! Voit lisätä tuotteen ostoskoriin.', false);
        hideModal();

    } catch (error) {
        console.error('A critical error occurred in applyCropAndGenerateTexture:', error);
        showMessage('Virhe kuvan käsittelyssä. Yritä uudelleen.', true);
        // Ensure button is usable again after an error
        if (addToCartButton) addToCartButton.disabled = true; // Keep it disabled as the process failed
        uploadedImageUrl = null; // Clear the failed URL

    } finally {
        isLoadingTexture = false;
        // Only enable the button if the process was fully successful
        if (uploadedImageUrl) {
            if (addToCartButton) addToCartButton.disabled = false;
        }
    }
}

// --- REVISED combineTextures function (v8 - Relative Guideline Mapping) ---
function combineTextures(baseImageElement, overlayImageElement, blendMode = 'multiply', cropState, cropViewWidth, cropViewHeight) {
    console.log('[DIAGNOSTIC LOG - combineTextures] Entered. blendMode:', blendMode);
    console.log('[DIAGNOSTIC LOG - combineTextures] cropState received:', JSON.stringify(cropState));
    console.log('[DIAGNOSTIC LOG - combineTextures] cropViewWidth:', cropViewWidth, 'cropViewHeight:', cropViewHeight);
    console.log('[DIAGNOSTIC LOG - combineTextures] overlayImageElement passed src (first 100 chars):', overlayImageElement && overlayImageElement.src ? overlayImageElement.src.substring(0,100) + '...' : 'N/A');
    console.log('[DIAGNOSTIC LOG - combineTextures] baseImageElement passed src (first 100 chars):', baseImageElement && baseImageElement.src ? baseImageElement.src.substring(0,100) + '...' : 'N/A');
    // Validate inputs
    if (!overlayImageElement || !cropState || !cropViewWidth || !cropViewHeight || cropState.imageWidth <= 0 || cropState.imageHeight <= 0 || cropViewWidth <= 0 || cropViewHeight <= 0) {
        console.error("CombineTextures (v8): Missing or invalid arguments/state.", {
             hasBase: !!baseImageElement, hasOverlay: !!overlayImageElement, cropState, cropViewWidth, cropViewHeight
         });
        return null;
    }

    // The user's zoom from the crop tool is the source of truth.
    let finalEffectiveScale = cropState.scale;
     if (Math.abs(finalEffectiveScale) < 0.001) { // Prevent division by zero/tiny scales
         console.warn("CombineTextures (v8): Final effective scale is extremely small, using fallback.", finalEffectiveScale);
         finalEffectiveScale = 0.001;
     }

    try {
        const finalCanvas = document.createElement('canvas');
        finalCanvas.width = FINAL_TEXTURE_SIZE;
        finalCanvas.height = FINAL_TEXTURE_SIZE;
        const ctx = finalCanvas.getContext('2d');
        if (!ctx) { throw new Error("Could not get 2D context for final texture"); }

        // 1. Draw base texture (optional)
        if (baseImageElement) {
           try { ctx.drawImage(baseImageElement, 0, 0, finalCanvas.width, finalCanvas.height); }
           catch (e) { console.error("Error drawing base wood texture:", e); ctx.fillStyle = '#cccccc'; ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height); }
        } else { ctx.fillStyle = '#f0f0f0'; ctx.fillRect(0, 0, finalCanvas.width, finalCanvas.height); }

        // 2. Set blend mode
        ctx.globalCompositeOperation = baseImageElement ? blendMode : 'source-over';

        // --- RELATIVE SCALING CALCULATION (v8) ---

        // a. Calculate the base scale factor of the image fitted into the modal viewport
        const imgAspect = cropState.imageWidth / cropState.imageHeight;
        const viewAspect = cropViewWidth / cropViewHeight;
        let modalBaseScaleFactor;
        if (imgAspect > viewAspect) { modalBaseScaleFactor = cropViewWidth / cropState.imageWidth; } // Fit width
        else { modalBaseScaleFactor = cropViewHeight / cropState.imageHeight; } // Fit height

         // Prevent extremely small base scales if dimensions are weird
         if (modalBaseScaleFactor <= 0 || !isFinite(modalBaseScaleFactor)) {
             console.warn("CombineTextures (v8): Calculated modalBaseScaleFactor is invalid, using fallback.", modalBaseScaleFactor);
             modalBaseScaleFactor = 0.1; // Use a fallback scale
         }

        // b. Determine the visual size (in modal pixels) corresponding to the guideline area
        //    Use the minimum dimension of the crop view container.
        const guidelineVisualDiameter = Math.min(cropViewWidth, cropViewHeight);

        // c. Calculate how many pixels on the *original image* correspond to this guideline diameter,
        //    considering the user's zoom (`finalEffectiveScale` includes manual adjustment).
        const combinedScaleFactor = modalBaseScaleFactor * finalEffectiveScale;
        if (Math.abs(combinedScaleFactor) < 1e-9) { // Use a very small threshold to avoid division by zero
             console.error("CombineTextures (v8): Combined scale factor is too close to zero.", combinedScaleFactor);
             // Return canvas with just base texture or an error indicator
             ctx.globalCompositeOperation = 'source-over';
             ctx.fillStyle = 'rgba(255,0,0,0.2)'; ctx.fillRect(0,0,finalCanvas.width, finalCanvas.height);
             ctx.fillStyle = 'white'; ctx.fillText('Scale Error', 10, 20);
             return finalCanvas;
        }
        const sourceSquareSide = guidelineVisualDiameter / combinedScaleFactor;

        // d. Calculate the center point on the *original image* corresponding to the modal center, adjusted for panning.
        const sourceCenterX = (cropState.imageWidth / 2) - (cropState.offsetX / combinedScaleFactor);
        const sourceCenterY = (cropState.imageHeight / 2) - (cropState.offsetY / combinedScaleFactor);

        // e. Calculate top-left corner (sx, sy) of the source rectangle on the original image.
        const sx = sourceCenterX - (sourceSquareSide / 2);
        const sy = sourceCenterY - (sourceSquareSide / 2);

        // --- DEBUG LOGS (Keep Active!) ---
        console.log(`--- Combine Textures Debug (v8 - Relative Guideline Mapping) ---`);
        // For combineTextures, we now use material and hook-specific constants:
        const manualVertOffset = currentMaterialType === 'wood' 
            ? (currentHookType === 'gold' ? WOOD_GOLD_MANUAL_VERTICAL_OFFSET_FACTOR : WOOD_MANUAL_VERTICAL_OFFSET_FACTOR)
            : (currentHookType === 'gold' ? ACRYLIC_GOLD_MANUAL_VERTICAL_OFFSET_FACTOR : MANUAL_VERTICAL_OFFSET_FACTOR);
        const manualScaleAdjust = currentMaterialType === 'wood' 
            ? (currentHookType === 'gold' ? WOOD_GOLD_MANUAL_TEXTURE_SCALE_ADJUSTMENT : WOOD_MANUAL_TEXTURE_SCALE_ADJUSTMENT)
            : (currentHookType === 'gold' ? ACRYLIC_GOLD_MANUAL_TEXTURE_SCALE_ADJUSTMENT : MANUAL_TEXTURE_SCALE_ADJUSTMENT);
        console.log(`${currentMaterialType} ${currentHookType} Manual Vert Offset: ${manualVertOffset}, Manual Scale Adjust: ${manualScaleAdjust}`);
        console.log(`Crop State: scale=${cropState.scale.toFixed(3)}, offsetX=${cropState.offsetX.toFixed(0)}, offsetY=${cropState.offsetY.toFixed(0)}`);
        console.log(`combineTextures - Final Effective Scale Used: ${finalEffectiveScale.toFixed(3)}`);
        console.log(`Crop View Dimensions: ${cropViewWidth} x ${cropViewHeight}`);
        console.log(`Modal Base Scale Factor (Fit): ${modalBaseScaleFactor.toFixed(4)}`);
        console.log(`Guideline Visual Diameter (used): ${guidelineVisualDiameter.toFixed(1)} (min of view dimensions)`);
        console.log(`Combined Scale Factor (Base * Effective): ${combinedScaleFactor.toFixed(4)}`);
        console.log(`Calculated Source Square Side: ${sourceSquareSide.toFixed(1)} (Guideline Visual Diameter / Combined Scale Factor)`);
        console.log(`Calculated Source Center: x=${sourceCenterX.toFixed(1)}, y=${sourceCenterY.toFixed(1)}`);
        console.log(`Vertical Nudge Amount: ${verticalNudge.toFixed(1)}`);
        console.log(`Final Source Rect TL: sx=${sx.toFixed(1)}, sy=${sy.toFixed(1)} (sy_original=${sy_original.toFixed(1)})`);
        console.log(`Final Draw Args: sx=${sx.toFixed(1)}, sy=${sy.toFixed(1)}, sW=${sourceSquareSide.toFixed(1)}, sH=${sourceSquareSide.toFixed(1)}`);
        console.log(`Overlay Image Element:`, overlayImageElement);
        console.log(`---------------------------------------------------------------`);
        // --- END DEBUG LOGS ---

        // 3. Draw the calculated portion onto the final canvas
        try {
             if (sourceSquareSide > 0 && isFinite(sx) && isFinite(sy) && overlayImageElement.naturalWidth > 0 && overlayImageElement.naturalHeight > 0) {
                ctx.globalAlpha = 0.9; // Make image 90% opaque to show wood grain
                ctx.drawImage(
                    overlayImageElement,
                    sx, sy, sourceSquareSide, sourceSquareSide, // Source: SQUARE area corresponding to guideline view
                    0, 0, finalCanvas.width, finalCanvas.height // Destination: entire final canvas
                );
                ctx.globalAlpha = 1.0; // Reset alpha for any subsequent drawing
             } else {
                console.warn("CombineTextures (v8): Skipping draw overlay - invalid source dimensions or coordinates calculated.", {sx, sy, sourceSquareSide});
             }
        } catch (e) {
            console.error("Error drawing overlay image in combineTextures (v8):", e);
            ctx.fillStyle = 'rgba(255,0,0,0.5)'; ctx.fillRect(0,0,finalCanvas.width, finalCanvas.height);
            ctx.fillStyle = 'white'; ctx.fillText('Draw Error', 10, 20);
        }

        // 4. Reset blend mode
        ctx.globalCompositeOperation = 'source-over';

        console.log(`Combined final texture (Relative Guideline Mapping v8).`);
        return finalCanvas;

    } catch (error) {
        console.error("Final canvas texture combination failed (v8):", error);
        return null;
    }
} // End of function combineTextures (v8)


// --- Configure and Apply Texture ---
function configureAndApplyTexture(texture) {
    texture.flipY = false;
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.magFilter = THREE.LinearFilter;
    texture.encoding = THREE.sRGBEncoding;

    // --- Texture Mapping Correction ---
    // Clamp to edge prevents the texture from repeating at the borders.
    texture.wrapS = THREE.ClampToEdgeWrapping;
    texture.wrapT = THREE.ClampToEdgeWrapping;

    // Apply UV scale and offset corrections to fix zoom and alignment in the 3D preview.
    let uvScale, verticalNudge;
    
    if (currentMaterialType === 'wood') {
        uvScale = currentHookType === 'gold' ? WOOD_GOLD_UV_SCALE_CORRECTION : WOOD_UV_SCALE_CORRECTION;
        verticalNudge = currentHookType === 'gold' ? WOOD_GOLD_UV_VERTICAL_OFFSET : WOOD_UV_VERTICAL_OFFSET;
    } else {
        uvScale = currentHookType === 'gold' ? ACRYLIC_GOLD_UV_SCALE_CORRECTION : ACRYLIC_UV_SCALE_CORRECTION;
        verticalNudge = currentHookType === 'gold' ? ACRYLIC_GOLD_UV_VERTICAL_OFFSET : ACRYLIC_UV_VERTICAL_OFFSET;
    }

    // Calculate the base offset required to keep the texture centered after scaling.
    const baseOffset = (1 - uvScale) / 2;

    // Apply the scale and the final calculated offset (with the vertical nudge).
    texture.repeat.set(uvScale, uvScale);
    texture.offset.set(baseOffset, baseOffset + verticalNudge);

    texture.needsUpdate = true;

    console.log(`configureAndApplyTexture called. Current material: ${currentMaterialType}`);
    console.log(`Texture to apply:`, texture);
    console.log(`Front material available: ${!!frontMaterial}, Back material available: ${!!backMaterial}`);

    if (currentMaterialType === 'acrylic') {
        if (frontMaterial) {
            frontMaterial.transparent = false;
            frontMaterial.blending = THREE.NormalBlending;
        }
        if (backMaterial) {
            backMaterial.transparent = false;
            backMaterial.blending = THREE.NormalBlending;
        }
    } else {
        // Optionally, ensure wood is not transparent and reset blending if it was set before
        if (frontMaterial) {
            frontMaterial.transparent = false;
            // frontMaterial.blending = THREE.NormalBlending; // Or whatever default is appropriate
        }
        if (backMaterial) {
            backMaterial.transparent = false;
            // backMaterial.blending = THREE.NormalBlending;
        }
    }

    if (frontMaterial) { 
        frontMaterial.color.set(0xffffff); // Ensure material base color is white
        
        // For wood materials, blend uploaded texture with existing wood texture
        if (currentMaterialType === 'wood' && woodBaseTexture) {
            // Create a canvas to blend the textures
            const blendCanvas = document.createElement('canvas');
            blendCanvas.width = 1024;
            blendCanvas.height = 1024;
            const blendCtx = blendCanvas.getContext('2d');
            
            // Draw wood texture as base
            const woodImg = new Image();
            woodImg.crossOrigin = 'anonymous';
            woodImg.onload = () => {
                blendCtx.drawImage(woodImg, 0, 0, 1024, 1024);
                
                // Draw uploaded texture on top
                const uploadImg = new Image();
                uploadImg.crossOrigin = 'anonymous';
                uploadImg.onload = () => {
                    blendCtx.drawImage(uploadImg, 0, 0, 1024, 1024);
                    
                    // Create new texture from blended canvas
                    const blendedTexture = new THREE.CanvasTexture(blendCanvas);
                    blendedTexture.flipY = false;
                    blendedTexture.wrapS = THREE.ClampToEdgeWrapping;
                    blendedTexture.wrapT = THREE.ClampToEdgeWrapping;
                    blendedTexture.encoding = THREE.sRGBEncoding;
                    // Don't apply UV scaling to blended texture to avoid stretching
                    blendedTexture.repeat.set(1, 1);
                    blendedTexture.offset.set(0, 0);
                    
                    frontMaterial.map = blendedTexture;
                    frontMaterial.needsUpdate = true;
                };
                uploadImg.src = texture.image.src;
            };
            woodImg.src = woodBaseTexture.image.src;
        } else if (currentMaterialType === 'acrylic') {
            // Flatten transparent images onto white background for acrylic
            const flattenCanvas = document.createElement('canvas');
            flattenCanvas.width = 1024;
            flattenCanvas.height = 1024;
            const flattenCtx = flattenCanvas.getContext('2d');

            // Fill with white
            flattenCtx.fillStyle = '#FFFFFF';
            flattenCtx.fillRect(0, 0, 1024, 1024);

            // Draw uploaded texture on top
            const uploadImg = new Image();
            uploadImg.crossOrigin = 'anonymous';
            uploadImg.onload = () => {
                flattenCtx.drawImage(uploadImg, 0, 0, 1024, 1024);
                
                const flattenedTexture = new THREE.CanvasTexture(flattenCanvas);
                flattenedTexture.flipY = false;
                flattenedTexture.wrapS = THREE.ClampToEdgeWrapping;
                flattenedTexture.wrapT = THREE.ClampToEdgeWrapping;
                flattenedTexture.encoding = THREE.sRGBEncoding;
                // Use same repeat/offset as calculated for the original texture
                flattenedTexture.repeat.copy(texture.repeat);
                flattenedTexture.offset.copy(texture.offset);
                
                frontMaterial.map = flattenedTexture;
                frontMaterial.needsUpdate = true;
            };
            uploadImg.src = texture.image.src;
        } else {
            // For other cases, use uploaded texture directly
            frontMaterial.map = texture;
        }
        
        frontMaterial.needsUpdate = true; 
        console.log('Tekstuuri asetettu etumateriaalille.');
    } else {
        console.log('Front material not found, cannot apply texture.');
    }
    if (backMaterial) { 
        backMaterial.color.set(0xffffff); // Ensure material base color is white
        
        // For wood materials, blend uploaded texture with existing wood texture
        if (currentMaterialType === 'wood' && woodBaseTexture) {
            // Create a canvas to blend the textures
            const blendCanvas = document.createElement('canvas');
            blendCanvas.width = 1024;
            blendCanvas.height = 1024;
            const blendCtx = blendCanvas.getContext('2d');
            
            // Draw wood texture as base
            const woodImg = new Image();
            woodImg.crossOrigin = 'anonymous';
            woodImg.onload = () => {
                blendCtx.drawImage(woodImg, 0, 0, 1024, 1024);
                
                // Draw uploaded texture on top
                const uploadImg = new Image();
                uploadImg.crossOrigin = 'anonymous';
                uploadImg.onload = () => {
                    blendCtx.drawImage(uploadImg, 0, 0, 1024, 1024);
                    
                    // Create new texture from blended canvas
                    const blendedTexture = new THREE.CanvasTexture(blendCanvas);
                    blendedTexture.flipY = false;
                    blendedTexture.wrapS = THREE.ClampToEdgeWrapping;
                    blendedTexture.wrapT = THREE.ClampToEdgeWrapping;
                    blendedTexture.encoding = THREE.sRGBEncoding;
                    // Don't apply UV scaling to blended texture to avoid stretching
                    blendedTexture.repeat.set(1, 1);
                    blendedTexture.offset.set(0, 0);
                    
                    backMaterial.map = blendedTexture;
                    backMaterial.needsUpdate = true;
                };
                uploadImg.src = texture.image.src;
            };
            woodImg.src = woodBaseTexture.image.src;
        } else if (currentMaterialType === 'acrylic') {
            // Flatten transparent images onto white background for acrylic
            const flattenCanvas = document.createElement('canvas');
            flattenCanvas.width = 1024;
            flattenCanvas.height = 1024;
            const flattenCtx = flattenCanvas.getContext('2d');

            // Fill with white
            flattenCtx.fillStyle = '#FFFFFF';
            flattenCtx.fillRect(0, 0, 1024, 1024);

            // Draw uploaded texture on top
            const uploadImg = new Image();
            uploadImg.crossOrigin = 'anonymous';
            uploadImg.onload = () => {
                flattenCtx.drawImage(uploadImg, 0, 0, 1024, 1024);
                
                const flattenedTexture = new THREE.CanvasTexture(flattenCanvas);
                flattenedTexture.flipY = false;
                flattenedTexture.wrapS = THREE.ClampToEdgeWrapping;
                flattenedTexture.wrapT = THREE.ClampToEdgeWrapping;
                flattenedTexture.encoding = THREE.sRGBEncoding;
                // Use same repeat/offset as calculated for the original texture
                flattenedTexture.repeat.copy(texture.repeat);
                flattenedTexture.offset.copy(texture.offset);
                
                backMaterial.map = flattenedTexture;
                backMaterial.needsUpdate = true;
            };
            uploadImg.src = texture.image.src;
        } else {
            // For acrylic or when no wood texture, use uploaded texture directly
            backMaterial.map = texture;
        }
        
        backMaterial.needsUpdate = true; 
        console.log('Texture applied to backMaterial.');
    } else {
        console.log('Back material not found, cannot apply texture.');
    }
    console.log("configureAndApplyTexture finished.");

    // After texture is applied, ensure autorotation starts/resumes.
    if (autorotationResumeTimer) {
        clearTimeout(autorotationResumeTimer);
        autorotationResumeTimer = null;
    }
    console.log('Texture applied/changed. Enabling autorotation.');
    userHasInteracted = false; // Applying texture overrides previous interaction state for rotation purposes.
    isAutorotating = true;
}

function resetTexture() {
    // Only apply wood texture for wood materials, null for acrylic
    const textureToApply = (currentMaterialType === 'wood' && woodBaseTexture) ? woodBaseTexture : null;
    
    if (frontMaterial) { 
        frontMaterial.map = textureToApply; 
        frontMaterial.needsUpdate = true; 
    }
    if (backMaterial) { 
        backMaterial.map = textureToApply; 
        backMaterial.needsUpdate = true; 
    }
    
    uploadedImageUrl = null;
    customerCropSettings = null; // Clear settings on reset
    if (imageUploadInput) imageUploadInput.value = null;
    if (addToCartButton) addToCartButton.disabled = true;
    console.log(`Texture reset on 3D model (${currentMaterialType}) and settings cleared.`);
    showMessage("", false); // Clear any messages
}

// --- Swipe Hint Animation Function ---
function startSwipeHintAnimation() {
    if (!isModelLoaded || !controls || typeof gsap === 'undefined') {
        console.log("Cannot start swipe hint: Model/Controls not ready or GSAP missing.");
        return;
    }

    console.log("Starting swipe hint animation...");

    const initialPosition = new THREE.Vector3().copy(camera.position);
    const rotationAngle = Math.PI / 5; // Angle to rotate (radians) - adjust for more/less rotation (e.g., Math.PI / 10)
    const duration = 0.7; // Duration of swipe out (seconds)
    const returnDuration = 0.7; // Duration of swipe back (seconds)
    const delay = 0.8; // Delay before animation starts (seconds)

    // Calculate target position for the swipe
    const targetPosition = new THREE.Vector3()
                                .copy(initialPosition)
                                .applyAxisAngle(new THREE.Vector3(0, 1, 0), rotationAngle); // Rotate around Y-axis

    // Create a GSAP Timeline for the sequence
    const tl = gsap.timeline({
        delay: delay, // Wait a bit after load
        onComplete: () => {
            console.log("Swipe hint animation finished.");
             // Ensure final position is exactly the initial one after animation
            camera.position.copy(initialPosition);
            controls.update();
        }
    });

    // Animate camera position 'out' (swipe effect)
    tl.to(camera.position, {
        x: targetPosition.x,
        y: targetPosition.y,
        z: targetPosition.z,
        duration: duration,
        ease: "power1.inOut",
        onUpdate: function() {
            controls.update(); // Update controls during animation
        }
    });

    // Animate camera position 'back' to initial
    tl.to(camera.position, {
        x: initialPosition.x,
        y: initialPosition.y,
        z: initialPosition.z,
        duration: returnDuration,
        ease: "power1.inOut",
        onUpdate: function() {
            controls.update(); // Update controls during animation
        }
    });
}

// --- Upload Image to Cloudinary (Unchanged) ---
async function uploadImageToServer(fileObject) {
    console.log("Attempting to upload original file to Cloudinary...");
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`;
    const formData = new FormData();
    formData.append('file', fileObject);
    formData.append('upload_preset', CLOUDINARY_UPLOAD_PRESET);
    try {
        const response = await fetch(url, { method: 'POST', body: formData });
        if (!response.ok) {
            let errorData; try { errorData = await response.json(); } catch (e) { /* ignore */ }
            console.error("Cloudinary upload error response:", errorData);
            throw new Error(`Cloudinary upload failed: ${response.statusText} ${errorData?.error?.message || ''}`);
        }
        const data = await response.json();
        console.log("Cloudinary upload success:", data);
        if (!data.secure_url) throw new Error("Cloudinary response missing secure_url.");
        return data.secure_url;
    } catch (error) { console.error('Error uploading image to Cloudinary:', error); throw error; }
}

// --- Add to Cart Logic (with Crop Properties) ---
function addItemToCart() {
    // Check if both the image URL and crop settings are ready
    if (!uploadedImageUrl) {
        showMessage("Lataa ensin kuva.", true);
        return;
    }
    if (!customerCropSettings) {
         showMessage("Crop settings missing. Please apply image settings again.", true);
         // Optionally, could try to re-run applyCropAndGenerateTexture logic here,
         // but simpler to ask user to re-apply if state is lost.
         return;
    }
    if (isLoadingTexture) {
        showMessage("Odota kuvan prosessointia...", true);
        return;
    }

    showMessage("Lisätään ostoskoriin...", false);
    addToCartButton.disabled = true;

    // --- Prepare Line Item Properties ---
    // Use names starting with '_' to hide them from customer on storefront by default
    // Convert numbers to strings for properties
    const properties = {
        'Muoto': currentShape === 'round' ? 'Pyöreä' : 'Suorakaide',
        'Materiaali': currentMaterialType === 'wood' ? 'Puu' : 'Akryyli',
        'Koukku': currentHookType === 'silver' ? 'Hopea' : 'Kulta',
        'Custom Image': uploadedImageUrl,
        '_Kuvan URL': uploadedImageUrl,
        '_Crop X': customerCropSettings.offsetX.toFixed(2),
        '_Crop Y': customerCropSettings.offsetY.toFixed(2),
        '_Crop Leveys': customerCropSettings.imageWidth.toFixed(2),
        '_Crop Korkeus': customerCropSettings.imageHeight.toFixed(2),
        '_Crop Zoom': customerCropSettings.scale.toFixed(2),
        '_Crop ImgWidth': String(customerCropSettings.imageWidth), // Original width
        '_Crop ImgHeight': String(customerCropSettings.imageHeight) // Original height
    };
    // --- End Properties ---

    const data = {
        items: [{
            id: currentVariantId,
            quantity: 1,
            properties: properties // Add the properties object here
        }]
    };

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            // Try to get error message from Shopify if available
            return response.json().then(errorData => {
                throw new Error(errorData.description || errorData.message || `Shopify Cart Error: ${response.status}`);
            }).catch(() => { // Fallback if errorData is not JSON or doesn't have description/message
                throw new Error(`Network Cart Error: ${response.status}`);
            });
        }
        return response.json();
    })
    .then(cartResponse => {
        console.log('[SUCCESS] Cart add.js responded. cartResponse:', cartResponse);
        console.log('[SUCCESS] Properties sent:', properties);

        console.log('[SUCCESS] Cart add.js responded. cartResponse:', cartResponse);
    // The main success message "Tuote lisätty ostoskoriin!" is now handled within the cart notification logic block below,
    // either by the notification itself appearing, or via fallback calls to showMessage().

    // Dispatch standard cart events. These might be used by other scripts or the theme itself.
    console.log('[SUCCESS] Dispatching cart:updated event with cartResponse:', cartResponse);
    document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: { cart: cartResponse }
    }));

        console.log('[SUCCESS] After dispatching cart:updated.');

        console.log('[SUCCESS] Attempting to dispatch item:added event...');
        document.dispatchEvent(new CustomEvent('item:added', { 
            bubbles: true,
            detail: { cart: cartResponse }
        }));
        console.log('[SUCCESS] After dispatching item:added.');

        // Fetch updated cart to refresh cart icon count
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                console.log('[SUCCESS] Fetched updated cart:', cart);
                
                // Update cart icon bubble
                const cartIconBubble = document.getElementById('cart-icon-bubble');
                if (cartIconBubble) {
                    const cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
                    const cartItemCount = cartIconBubble.querySelector('.cart-item-count');
                    
                    if (cartCountBubble && cartItemCount) {
                        cartItemCount.textContent = cart.item_count;
                        if (cart.item_count > 0) {
                            cartCountBubble.style.display = 'flex';
                        }
                    }
                }
                
                // Try to open cart notification if it exists
                const cartNotificationElement = document.querySelector('cart-notification');
                if (cartNotificationElement && typeof cartNotificationElement.open === 'function') {
                    cartNotificationElement.open();
                    console.log('[SUCCESS] Opened cart notification.');
                } else {
                    console.log('[SUCCESS] Cart notification element not found or no open method.');
                }
                
                showMessage("Tuote lisätty ostoskoriin!", false);
            })
            .catch(error => {
                console.error('[SUCCESS] Error fetching cart:', error);
                showMessage("Tuote lisätty ostoskoriin!", false);
            });

        // Disable the Add to Cart button immediately
        if (addToCartButton) {
            addToCartButton.disabled = true; 
            console.log('[SUCCESS] Add to cart button disabled immediately.');
        } else {
            console.log('[SUCCESS] Add to cart button not found to disable.');
        }

        // Schedule the reset of customizer UI elements after a delay
        setTimeout(() => {
            console.log('[addItemToCart] Delayed UI reset executing...');
            console.log('[SUCCESS] Attempting to reset UI for next customization (delayed)...');
            resetTexture(); 
            console.log('[SUCCESS] After resetTexture() (delayed).');
            customerCropSettings = null; 
            uploadedImageUrl = null;
            if (imageUploadInput) imageUploadInput.value = null;
            console.log('[SUCCESS] After clearing crop settings and image URL (delayed).');
            console.log('[addItemToCart] Delayed UI reset finished.');
        }, 3000); // 3-second delay (3000 milliseconds)

        console.log('[SUCCESS] End of success block (UI reset scheduled).');
    })
    .catch((error) => {
        console.error('Error adding item to cart:', error);
        showMessage(`Virhe lisättäessä ostoskoriin: ${error.message}`, true);
        if (addToCartButton) addToCartButton.disabled = false; // Re-enable button on error
    });
}

// --- Utility Functions ---
function showMessage(msg, isError = false) {
    console.log('[showMessage] Called with message:', msg, 'isError:', isError);
    if (messageElement) {
        console.log('[showMessage] messageElement found. Current text:', messageElement.innerText);
        messageElement.innerText = msg;
        messageElement.style.color = '#7a9db5'; // Use #7a9db5 for all message text
        messageElement.style.backgroundColor = ''; // Ensure no background color
        messageElement.style.padding = ''; // Ensure no padding
        messageElement.style.borderRadius = ''; // Ensure no border radius
        messageElement.style.display = 'block'; // Make message a block element for consistent positioning
        messageElement.style.marginTop = '10px'; // Keep some top margin
        console.log('[showMessage] Message set to:', msg, 'Style applied.');
    } else {
        console.error('[showMessage] messageElement is NOT defined or null. Cannot display message.');
    }
}

// --- Animation Loop (with Autorotation Logic) ---
function animate() {
    requestAnimationFrame(animate); // Keep the loop going

    // Update OrbitControls (handles damping, etc.)
    if (controls) controls.update();

    // --- Autorotation Logic ---
    // Check flags: autorotation enabled? model loaded? user hasn't touched it yet?
    if (isAutorotating && earringModel && !userHasInteracted) {
        const rotationSpeed = 0.003; // Increased from 0.006 for faster spinning
        earringModel.rotation.y += rotationSpeed; // Rotate the model around its vertical (Y) axis
    }
    // --- End Autorotation Logic ---

    // Render the scene
    if (renderer && scene && camera) {
        renderer.render(scene, camera);
    }
}

function onWindowResize() {
    if (camera && renderer && canvasContainer) {
        camera.aspect = canvasContainer.clientWidth / canvasContainer.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(canvasContainer.clientWidth, canvasContainer.clientHeight);
    }
}

// --- Event Listeners ---
document.addEventListener('DOMContentLoaded', () => {
    // Initialize 3D scene if container exists
    if (document.getElementById('earring-canvas-container')) {
        init3D();
        
        // Get references to all DOM elements needed for the customizer
        // Note: canvasContainer, imageUploadInput, addToCartButton, messageElement, tabWood, tabAcrylic
        // are already global constants defined at the top of the script.
        
        cropModal = document.getElementById('image-crop-modal');
        cropCanvas = document.getElementById('crop-canvas');
        
        // Initialize all required modal elements
        zoomSlider = document.getElementById('zoom-slider');
        applyCropBtn = document.getElementById('apply-crop-btn');
        cancelCropBtn = document.getElementById('cancel-crop-btn');
        closeModalBtn = document.getElementById('crop-modal-close');
        zoomInBtn = document.getElementById('zoom-in-btn');
        zoomOutBtn = document.getElementById('zoom-out-btn');
        cropCanvasContainer = document.getElementById('crop-canvas-container');
        
        if (cropCanvas) {
            cropCtx = cropCanvas.getContext('2d');
            if (!cropCtx) console.error("Failed to get 2D context for crop canvas");
        } else {
            console.warn("Cropping canvas element (#crop-canvas) not found. Cropping disabled.");
        }

        // Setup event listeners for main customizer controls
        if (imageUploadInput) {
            imageUploadInput.addEventListener('change', handleImageUpload);
            // Consider if it should start disabled: imageUploadInput.disabled = true;
        } else {
            console.warn("'image-upload' element not found.");
        }

        if (addToCartButton) {
            addToCartButton.addEventListener('click', addItemToCart);
            // addToCartButton starts disabled via HTML or can be set here
        } else {
            console.warn("'add-custom-to-cart-button' element not found.");
        }

        // Add event listeners for material tabs
        if (tabWood) {
            tabWood.addEventListener('click', () => switchMaterial('wood'));
        } else {
            console.warn("'tab-wood' element not found.");
        }
        if (tabAcrylic) {
            tabAcrylic.addEventListener('click', () => switchMaterial('acrylic'));
        } else {
            console.warn("'tab-acrylic' element not found.");
        }

        // Add event listeners for shape tabs
        const tabRound = document.getElementById('tab-round');
        const tabRectangle = document.getElementById('tab-rectangle');
        if (tabRound) {
            tabRound.addEventListener('click', () => switchShape('round'));
        } else {
            console.warn("'tab-round' element not found.");
        }
        if (tabRectangle) {
            tabRectangle.addEventListener('click', () => switchShape('rectangle'));
        } else {
            console.warn("'tab-rectangle' element not found.");
        }

        // Add event listeners for hook tabs
        if (tabSilverHook) {
            tabSilverHook.addEventListener('click', () => switchHook('silver'));
        } else {
            console.warn("'tab-silver-hook' element not found.");
        }
        if (tabGoldHook) {
            tabGoldHook.addEventListener('click', () => switchHook('gold'));
        } else {
            console.warn("'tab-gold-hook' element not found.");
        }

        // Initialize hook tabs visibility
        updateHookTabsVisibility();

        // Setup modal specific event listeners (only if modal exists)
        if (cropModal) {
           setupModalEventListeners();
        } else {
           console.warn("Cropping modal element (#image-crop-modal) not found. Cropping UI disabled.");
        }

    } else {
        console.error("Required element 'earring-canvas-container' not found on page load. Customizer not initialized.");
    }
});

document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('.accordion-button');

  accordionButtons.forEach(button => {
    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      const currentlyOpenPanel = document.querySelector('.accordion-panel[style*="max-height"]'); // Find open panel

      // Close ANY open panel that's not the clicked one
      if (currentlyOpenPanel && currentlyOpenPanel !== panel) {
          const openButton = document.querySelector(`[aria-controls="${currentlyOpenPanel.id}"]`);
          if (openButton) {
              openButton.setAttribute('aria-expanded', 'false');
          }
          currentlyOpenPanel.style.maxHeight = null;
          currentlyOpenPanel.style.paddingTop = '0';
          currentlyOpenPanel.style.paddingBottom = '0';
      }

      // Toggle the clicked button's state
      button.setAttribute('aria-expanded', !isExpanded);

      if (panel) {
        if (isExpanded) {
          // Close panel - ensure padding is fully removed
          panel.style.maxHeight = null;
          panel.style.paddingTop = '0';
          panel.style.paddingBottom = '0';
        } else {
          // Open panel
          panel.style.paddingTop = '15px';
          panel.style.paddingBottom = '15px';
          // Recalculate panel height after padding is applied
          setTimeout(() => {
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }, 10);
        }
      }
    });
  });

  // Ensure all initially closed panels have zero padding
  document.querySelectorAll('.accordion-panel').forEach(panel => {
    if (!panel.style.maxHeight) {
      panel.style.paddingTop = '0';
      panel.style.paddingBottom = '0';
    }
  });
});